'use client';
import {
  IMaker,
  IManufacturingProcess,
  IMaterial,
} from '@/src/interfaces/generated/contentful';
import {
  PageSection,
  Box,
  PageSectionTitle,
  Heading,
  Link,
} from '@/src/packages/components';
import { PageWrapper } from '@/src/packages/components/templates/PageWrapper';
import { PageSectionStack } from '@/src/packages/components/templates/PageSectionStack';
import { VideoManufacturing } from '@/src/packages/components/ui/Video';
import { Column, Grid } from '@/src/packages/components/ui/GridBox';
import { ArticleCard } from '@/src/packages/components/ui/ArticleCard';
import { getRoute } from '@/src/packages/utils/routes';
import { paths } from '@/src/packages/routes';
import { pathParams } from '@/src/packages/routes/pathParams.enum';
import { TemplateSidebar } from '@/src/packages/components/templates/TemplateSidebar';
import { ManufacturingLinks } from '@/src/packages/components/ui/Footer/Footer.config';
import NextLink from 'next/link';

const ManufacturingProcessesIndexPage = (props: {
  manufacturingprocesses: IManufacturingProcess[];
  materials: IMaterial[];
  suppliers: IMaker[];
}) => {
  const { manufacturingprocesses } = props;

  return (
    <TemplateSidebar title="Manufacturing processes" links={ManufacturingLinks}>
      <PageWrapper paddingTop={0}>
        <PageSectionStack>
          <PageSection>
            <Grid>
              {manufacturingprocesses.map((item, i) => {
                return (
                  <Column className="col-span-12 lg:col-span-6" key={i}>
                    <Box className="bg-background-secondary pb-24" key={i}>
                      <Box className="col-span-12 space-y-4 px-8 py-6 lg:col-span-6">
                        <Heading
                          as="h3"
                          size="h2"
                          className="font-serif text-2xl leading-none"
                        >
                          {item.fields.name}
                        </Heading>

                        <Link variant="solid" className="inline-block" asChild>
                          <NextLink
                            href={getRoute({
                              route: paths.MANUFACTURING_SINGLE,
                              params: {
                                [pathParams.MANUFACTURING_SINGLE]:
                                  item.fields.slug,
                              },
                            })}
                          >
                            Learn more
                          </NextLink>
                        </Link>
                      </Box>
                    </Box>
                  </Column>
                );
              })}
            </Grid>
          </PageSection>
        </PageSectionStack>
      </PageWrapper>
    </TemplateSidebar>
  );
};

export { ManufacturingProcessesIndexPage };
